import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { finalize, take } from 'rxjs/operators';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { NotaVentaService } from 'src/app/services/nota-venta.service';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { UnidadNegocioService } from 'src/app/services/unidad-negocio.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { NotaVentaCabeceraComponent } from './nota-venta-cabecera/nota-venta-cabecera.component';
import { NotaVentaDetallesComponent } from './nota-venta-detalles/nota-venta-detalles.component';

@Component({
  selector: 'app-add-nota-venta',
  templateUrl: './add-nota-venta.component.html',
  styleUrls: ['./add-nota-venta.component.scss'],
  providers: [SecurityService],
})
export class AddNotaVentaComponent implements OnInit {
  @ViewChild(NotaVentaCabeceraComponent, { static: true }) cabeceraComponent: NotaVentaCabeceraComponent;
  @ViewChild(NotaVentaDetallesComponent, { static: true }) detallesComponent: NotaVentaDetallesComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();

  mostrar: boolean = false;

  // Outputs
  @Output() onSaveNotaVenta: EventEmitter<void> = new EventEmitter<void>();

  // Data &  Tmp
  private rutEmpresa: number;
  private headerData = null;
  private currentProcess = null;
  private DetalleData = null;

  public permiteUnidadNegocio: boolean = false;
  optionsUnidadesDeNegocio: unidad_negocio[] = [];
  onEditingProduct: boolean = false;

  // Utils
  private log: any;
  mode: string = '';
  folio: number = 0;
  CloseNotaVentaEspUpdate: boolean = false;
  NotaVentaGuardada: any;
  ValidaGuardadoNotaVenta: any;
  processing: boolean = false;
  private saveAttemptSeq: number = 0;
  constructor(
    private accesolocalstorage: SecurityService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private notaVentaService: NotaVentaService,
    private parametroEmpresaService: ParametroEmpresaService,
    private unidadNegocioService: UnidadNegocioService
  ) {
    this.log = this.clog.log('MAIN');
  }

  private isSaveDebugEnabled(): boolean {
    try {
      return localStorage.getItem('debug.notaVenta.save') === '1';
    } catch {
      return false;
    }
  }

  private traceSave(attemptId: number, step: string, data?: any) {
    if (!this.isSaveDebugEnabled()) return;
    const payload = {
      ts: new Date().toISOString(),
      attemptId,
      step,
      mode: this.mode,
      folio: this.folio,
      proceso: this.currentProcess ? this.currentProcess.proceso : null,
      tipoDocumentoDTE:
        this.currentProcess && this.currentProcess.cabecera ? this.currentProcess.cabecera.tipoDocumentoDTE : null,
      data: typeof data === 'undefined' ? null : data,
    };

    // Dejar trazabilidad accesible desde consola.
    const w = window as any;
    w.__notaVentaSaveTrace = Array.isArray(w.__notaVentaSaveTrace) ? w.__notaVentaSaveTrace : [];
    w.__notaVentaSaveTrace.push(payload);

    this.log('[NV_SAVE_TRACE]', JSON.stringify(payload));
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    // this.log('process.env.NODE_ENV', process.env.NODE_ENV, process.env.NODE_ENV.toLowerCase().startsWith('dev'))
    this.parametroUnidadNegocio();
    this.loadUnidadNegocio();
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(this.rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;
    });
  }

  async loadUnidadNegocio() {
    return new Promise<void>((resolve) => {
      const inputParams = {
        entidad: {
          empresa_rut: this.rutEmpresa,
          tipo: 1,
        },
      };
      this.optionsUnidadesDeNegocio = [];
      this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
        const { registros } = respuesta;
        this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
          value: unidad_negocio.codigo,
          label: unidad_negocio.nombre,
        }));
        resolve();
      });
    });
  }

  handleHeaderDataChange(data) {
    this.detallesComponent.handleHeaderDataChange(data);
  }

  onApplyGlobalDiscount(descuento: { porcentajeDescuento: number; montoDescuento: number }) {
    if (!this.currentProcess) {
      // this.toastrService.warning('Debe agregar productos antes de aplicar el descuento.');
      return;
    }

    const proceso = this.currentProcess.proceso;
    const tipoDocumentoDTE = this.currentProcess.cabecera.tipoDocumentoDTE;

    // this.headerData = this.cabeceraComponent.getHeaderData();
    const detalle = this.detallesComponent.getDetalleData();

    const payload: any = {
      ...this.currentProcess,
      cabecera: {
        ...this.currentProcess.cabecera,
        porcentajeDescuento: descuento.porcentajeDescuento,
        montoDescuento: descuento.montoDescuento,
      },
      ProductDocument: detalle.productDocument,
    };
    delete payload.productDocument;

    this.processing = true;
    this.notaVentaService.AplicarDescuentoGlobal(proceso, tipoDocumentoDTE, payload)
      .subscribe(
        (currentProcess: any) => {
          this.processing = false;

          if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
            currentProcess.mensajes.forEach((mensaje) => {
              this.toastrService.error(mensaje.texto);
            });
            return;
          }

          this.currentProcess = currentProcess;
          this.detallesComponent.fillProductos(currentProcess);
          this.cabeceraComponent.resetDescuentoDirty();
          this.toastrService.success('Descuento global aplicado correctamente');
        },
        () => {
          this.processing = false;
          this.toastrService.error('No se pudo aplicar el descuento global');
        }
      );
  }

  async onAddProductoRequest(notaEsp) {
    const headerIsValid = this.cabeceraComponent.validate();
    if (!headerIsValid) {
      this.toastrService.warning('Complete datos de cabecera');
      return;
    }

    const detailIsValid = this.detallesComponent.validate();
    if (!detailIsValid) {
      this.toastrService.warning('Complete datos de detalle');
      return;
    }

    const producto = this.detallesComponent.createPayloadAddProducto();

    this.headerData = this.cabeceraComponent.getHeaderData();
    const payload: any = {
      cabecera: this.headerData,
      ProductDocument: [producto],
    };

    this.log('agregar', JSON.stringify(payload));

    if (this.currentProcess && this.currentProcess.proceso) payload.proceso = this.currentProcess.proceso;

    var currentProcess: any;
    if (notaEsp.mode === 'EDIT') {
      payload.folio = notaEsp.current.folio;
      payload.proceso = notaEsp.current.proceso;
      // EN EL MODO EDIT DEBE AGREGAR PRODUCTOS AL MISMO PROCESO Y NOTA DE VENTA GENERADA;
      currentProcess = await this.notaVentaService.AgregarProductoDeNotaEsp(payload).toPromise();
      currentProcess.folio = notaEsp.current.folio;
    } else {
      // EN EL MODO AGREGAR SE REALIZA TAL CUAL COMO ESTA
      currentProcess = await this.notaVentaService.AgregarProducto(payload).toPromise();
    }

    this.log('currentProcess', currentProcess);

    if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
      currentProcess.mensajes.forEach((mensaje) => {
        this.toastrService.error(mensaje.texto);
      });
      return;
    }

    if (!notaEsp || notaEsp.suppressSuccessToast !== true) {
      this.toastrService.success('Producto agregado con éxito');
    }
    this.currentProcess = currentProcess;
    this.cabeceraComponent.resetDescuentoDirty();
    this.detallesComponent.fillProductos(currentProcess);
    // this.log('Se agregó', producto)
    this.bloquearUnidadNegocioCabecera(producto);
    this.cabeceraComponent.disableContent();
  }

  bloquearUnidadNegocioCabecera(productoSeleccionado) {
    // this.log('bloquear unidad negocio', productoSeleccionado)
    this.cabeceraComponent.disableUnidadNegocio(productoSeleccionado ? productoSeleccionado.unidad_negocio_codigo : null);
  }

  changeOnEditingProduct(onEditingProduct: boolean) {
    this.onEditingProduct = onEditingProduct;
  }

  async onDeleteProductoRequest(nvEsp) {
    var currentProcess: any;
    const linea = nvEsp.producto.linea;
    if (nvEsp.mode === 'EDIT') {
      if (nvEsp.current) {
        this.currentProcess = nvEsp.current;
      }

      //ELIMINAR PRODUCTO DEL MISMO PROCESO GENERADO:
      currentProcess = await this.notaVentaService.EliminarProductoDelEdit(this.currentProcess.proceso, this.currentProcess.folio, this.currentProcess.cabecera.tipoDocumentoDTE, linea).toPromise();
      currentProcess.folio = nvEsp.current.folio;

      if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
        currentProcess.mensajes.forEach((mensaje) => {
          this.toastrService.error(mensaje.texto);
        });
        return;
      }
    } else {
      //*MODO ADD
      // this.log('Eliminar producto', this.currentProcess.proceso, this.currentProcess.cabecera.tipoDocumentoDTE, linea)
      currentProcess = await this.notaVentaService.EliminarProducto(this.currentProcess.proceso, this.currentProcess.cabecera.tipoDocumentoDTE, linea).toPromise();
      if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
        currentProcess.mensajes.forEach((mensaje) => {
          this.toastrService.error(mensaje.texto);
        });
        return;
      }
    }

    this.currentProcess = nvEsp.current;
    this.toastrService.success('Producto eliminado con éxito');
    this.detallesComponent.fillProductos(currentProcess);
  }

  //MOSTRAR ADD NOTA VENTA
  Show(show, mode) {
    // Limpiar completamente el estado antes de mostrar el formulario de nueva nota de venta
    this.clearContents();

    this.CloseNotaVentaEspUpdate = false;
    this.mostrar = show;
    this.mode = mode;
    this.cabeceraComponent.show();
    this.detallesComponent.show();
  }

  //MOSTRAR NOTA DE VENTA SELECCIONADA
  async LoadAndShow(nv, show, mode) {
    // Validar que se recibió una nota de venta válida
    if (!nv || !nv.folio) {
      this.toastrService.error('Error: No se pudo cargar la nota de venta. Datos inválidos.');
      return;
    }

    // Limpiar completamente el estado antes de cargar una nueva nota de venta
    this.clearContents();

    this.CloseNotaVentaEspUpdate = true;
    this.mostrar = show;
    this.mode = mode;
    this.folio = nv.folio;

    // Crear una copia profunda de la nota de venta para evitar referencias compartidas
    this.currentProcess = JSON.parse(JSON.stringify(nv));

    // La validación de folio después de la copia profunda es innecesaria y se ha eliminado.

    // Asegurarse de que las opciones de unidad de negocio estén cargadas antes de cargar la cabecera
    if (this.optionsUnidadesDeNegocio.length === 0) {
      await this.loadUnidadNegocio();
    }

    this.cabeceraComponent.Load(this.currentProcess, this.mode);
    const result = await this.resolveAfter2Seconds(this.currentProcess);
  }

  resolveAfter2Seconds(nv) {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.detallesComponent.Load(nv, this.mode);
      }, 100);
    });
  }

  private getDetalleCount(): number {
    return (this.DetalleData && this.DetalleData.productDocument) ? this.DetalleData.productDocument.length : 0;
  }

  private abortSave(attemptId: number, traceKey: string, message: string, extra?: any) {
    this.processing = false;
    this.toastrService.error(message);
    this.traceSave(attemptId, traceKey, extra);
  }

  private validateHeaderForAdd(attemptId: number): boolean {
    const headerIsValid = this.cabeceraComponent.validate();
    if (!headerIsValid) {
      this.abortSave(attemptId, 'invalid_header', 'Complete datos de cabecera');
      return false;
    }
    return true;
  }

  private validateDetalleForAdd(attemptId: number): boolean {
    if (!this.DetalleData || !this.DetalleData.productDocument || this.DetalleData.productDocument.length === 0) {
      this.abortSave(attemptId, 'invalid_detail_empty', 'Agregue productos a la nota de venta');
      return false;
    }
    return true;
  }

  private validateCurrentProcessForAdd(attemptId: number): boolean {
    if (!this.currentProcess || !this.currentProcess.proceso || !this.currentProcess.cabecera || !this.currentProcess.cabecera.tipoDocumentoDTE) {
      this.abortSave(attemptId, 'invalid_current_process', 'No existe proceso válido para guardar la nota de venta', this.currentProcess);
      return false;
    }
    return true;
  }

  private guardarNotaVentaAdd(attemptId: number, startedAt: number) {
    this.traceSave(attemptId, 'start_add', {
      header: typeof this.headerData === 'undefined' ? null : this.headerData,
      detalleCount: this.getDetalleCount(),
    });

    if (!this.validateHeaderForAdd(attemptId)) return;
    if (!this.validateDetalleForAdd(attemptId)) return;
    if (!this.validateCurrentProcessForAdd(attemptId)) return;

    this.traceSave(attemptId, 'request_create', {
      proceso: this.currentProcess.proceso,
      tipoDocumentoDTE: this.currentProcess.cabecera.tipoDocumentoDTE,
    });

    this.notaVentaService
      .GuardarProceso(this.currentProcess.proceso, this.currentProcess.cabecera.tipoDocumentoDTE)
      .pipe(
        take(1),
        finalize(() => {
          this.processing = false;
          this.traceSave(attemptId, 'finalize', { elapsedMs: Date.now() - startedAt });
        })
      )
      .subscribe(
        (currentProcess: any) => {
          this.traceSave(attemptId, 'response_create', currentProcess);

          if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
            currentProcess.mensajes.forEach((mensaje) => {
              this.toastrService.error(mensaje.texto);
            });
            return;
          }

          const { folio } = currentProcess.respuesta.cabecera;
          this.toastrService.success('Nota venta ' + folio + ' agregada con éxito');
          this.ValidaGuardadoNotaVenta = true;
          this.onSaveNotaVenta.emit(this.ValidaGuardadoNotaVenta);
          this.clearContents();
        },
        (error) => {
          this.traceSave(attemptId, 'error_create', {
            message: error && error.message ? error.message : null,
            status: error && typeof error.status !== 'undefined' ? error.status : null,
            error: error && typeof error.error !== 'undefined' ? error.error : null,
          });
          this.toastrService.error('No se pudo realizar la operación');
        }
      );
  }

  private buildUpdatePayload(): any {
    this.currentProcess.cabecera.ordenCompra = this.headerData.ordenCompra;
    // Incluir cabecera actual del formulario para que se persistan dirección/sucursal y resto de cambios
    this.currentProcess.cabecera = { ...this.currentProcess.cabecera, ...this.headerData };
    const payload: any = {
      ...this.currentProcess,
      ProductDocument: this.DetalleData.productDocument,
      DocumentTotal: this.DetalleData.documentTotal,
    };
    delete payload.productDocument;
    delete payload.documentTotal;
    return payload;
  }

  private guardarNotaVentaEdit(attemptId: number, startedAt: number) {
    const payload = this.buildUpdatePayload();

    this.traceSave(attemptId, 'request_update', {
      proceso: this.currentProcess ? this.currentProcess.proceso : null,
      tipoDocumentoDTE: this.currentProcess && this.currentProcess.cabecera ? this.currentProcess.cabecera.tipoDocumentoDTE : null,
      folio: this.folio,
      detalleCount: this.getDetalleCount(),
    });

    this.notaVentaService
      .UpdateProceso(this.currentProcess.proceso, this.currentProcess.cabecera.tipoDocumentoDTE, this.folio, payload)
      .pipe(
        take(1),
        finalize(() => {
          this.processing = false;
          this.traceSave(attemptId, 'finalize', { elapsedMs: Date.now() - startedAt });
        })
      )
      .subscribe(
        (currentProcess: any) => {
          this.traceSave(attemptId, 'response_update', currentProcess);

          if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
            currentProcess.mensajes.forEach((mensaje) => {
              this.toastrService.error(mensaje.texto);
            });
            return;
          }
          const { folio } = currentProcess.respuesta.cabecera;
          this.mostrar = false;
          this.NotaVentaGuardada = currentProcess;
          this.toastrService.success('Nota venta ' + folio + ' modificada exitosamente');
          this.onSaveNotaVenta.emit();

          this.onSuccess.emit();
          this.clearContents();
        },
        (error) => {
          this.traceSave(attemptId, 'error_update', {
            message: error && error.message ? error.message : null,
            status: error && typeof error.status !== 'undefined' ? error.status : null,
            error: error && typeof error.error !== 'undefined' ? error.error : null,
          });
          this.toastrService.error('No se pudo realizar la operación');
        }
      );
  }

  async guardarNotaVenta() {
    // Bloqueo fuerte ante doble ejecución (doble click / doble emisión).
    if (this.processing) {
      this.traceSave(this.saveAttemptSeq, 'ignored_processing_true');
      return;
    }

    this.processing = true;
    const attemptId = ++this.saveAttemptSeq;
    const startedAt = Date.now();

    //OBTENGO LOS DATOS DE CABECERA PARA PODER HACER USO DE ESTOS AL GUARDAR
    this.headerData = this.cabeceraComponent.getHeaderData();
    this.DetalleData = this.detallesComponent.getDetalleData();

    if (this.mode == 'ADD') {
      this.guardarNotaVentaAdd(attemptId, startedAt);
      return;
    }

    if (this.mode == 'EDIT') {
      this.guardarNotaVentaEdit(attemptId, startedAt);
      return;
    }

    this.processing = false;
    this.traceSave(attemptId, 'ignored_invalid_mode', { mode: this.mode });
  }

  clearContents() {
    // Limpiar completamente el estado para evitar contaminación entre notas de venta
    this.currentProcess = null;
    this.headerData = null;
    this.DetalleData = null;
    this.folio = 0;
    this.CloseNotaVentaEspUpdate = false;
    this.NotaVentaGuardada = null;
    this.ValidaGuardadoNotaVenta = null;
    this.processing = false;

    // Limpiar componentes hijos
    this.cabeceraComponent.clearContent();
    this.detallesComponent.clearContent();
  }

  clearFromButton() {
    this.modalConfirm.show(() => {
      this.clearContents();
    });
  }

  CloseNotaVenta() {
    //SI ES EDIT ACTUALIZAR TABLA DE PRODUCTOS
    if (this.mode != 'SHOW' && this.mode != 'ADD') {
      //OBTENER LOS DATOS DE DETALLE
      this.DetalleData = this.detallesComponent.getDetalleData();
      this.ValidaGuardadoNotaVenta = true;

      if (this.CloseNotaVentaEspUpdate == true) {
        //OBTENGO LOS DATOS DE CABECERA PARA PODER HACER USO DE ESTOS AL GUARDAR
        this.headerData = this.cabeceraComponent.getHeaderData();
        this.currentProcess.ProductDocument = this.DetalleData;
        // ACTUALIZAR NOTA DE VENTA (incluir cabecera actual para persistir dirección/sucursal y demás cambios)
        this.currentProcess.cabecera = { ...this.currentProcess.cabecera, ...this.headerData };
        this.currentProcess.ProductDocument = this.DetalleData.productDocument;
        this.currentProcess.DocumentTotal = this.DetalleData.documentTotal;
        //*TODO limpiar variable productDocument ya que se puede pisar con ProductDocument;
        delete this.currentProcess.productDocument;
        delete this.currentProcess.documentTotal;
        this.notaVentaService.UpdateProceso(this.currentProcess.proceso, this.currentProcess.cabecera.tipoDocumentoDTE, this.folio, this.currentProcess).subscribe(
          (currentProcess: any) => {
            this.log(currentProcess);

            if (currentProcess.mensajes && currentProcess.mensajes.length > 0) {
              currentProcess.mensajes.forEach((mensaje) => {
                this.toastrService.error(mensaje.texto);
              });
              // return;
            }
            // const { folio } = currentProcess.respuesta.cabecera;
          },
          (error) => {
            // this.toastrService.error('No se pudo realizar la operación')
          }
        );
      }
      // LIMPIAR VARIABLES
      this.clearContents();
      this.mostrar = false;

      this.onSuccess.emit(this.ValidaGuardadoNotaVenta);
    } else {
      this.ValidaGuardadoNotaVenta = false;
      this.clearContents();
      this.mostrar = false;
      this.onSuccess.emit(this.ValidaGuardadoNotaVenta);
    }
  }
}
